import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showFileUploader: false,
  showAllFiles: false,
  forFileManager: false,
  forAll: false,
  allFiles: [],
  folderFiles: [],
  IsMultiSelected: false,
  multiSelected: [],
  IsSingleSelected: false,
  singleSelected: null,
  isBulkEnable: false,
};

export const fileReducer = createSlice({
  name: "file",
  initialState,
  reducers: {
    setShowFileUploader: (state, action) => {
      state.showFileUploader = action.payload;
    },
    setShowAllFiles: (state, action) => {
      state.showAllFiles = action.payload;
    },
    setForFileManager: (state, action) => {
      state.forFileManager = action.payload;
    },

    setForAll: (state, action) => {
      state.forAll = action.payload;
    },
    setAllFiles: (state, action) => {
      state.allFiles = action.payload;
    },
    setFolderFiles: (state, action) => {
      state.folderFiles = action.payload;
    },
    setIsMultiSelected: (state, action) => {
      state.IsMultiSelected = action.payload;
    },
    setMultiSelected: (state, action) => {
      state.multiSelected = action.payload;
    },
    setIsSingleSelected: (state, action) => {
      state.IsSingleSelected = action.payload;
    },
    setSingleSelected: (state, action) => {
      state.singleSelected = action.payload;
    },
    setIsBulkEnable: (state, action) => {
      state.isBulkEnable = action.payload;
    },
  },
});

export const {
  setShowFileUploader,
  setShowAllFiles,
  setForFileManager,
  setForAll,
  setAllFiles,
  setFolderFiles,
  setIsMultiSelected,
  setMultiSelected,
  setIsSingleSelected,
  setSingleSelected,
  setIsBulkEnable,
} = fileReducer.actions;

export default fileReducer.reducer;
